import { useEffect, useState } from "react";

const DARK_QUERY = "(prefers-color-scheme: dark)";

/** Follows a change of the system colour scheme without a reload. */
export const useSystemDark = () => {
  const [dark, setDark] = useState(() => window.matchMedia(DARK_QUERY).matches);
  useEffect(() => {
    const mql = window.matchMedia(DARK_QUERY);
    const onChange = () => setDark(mql.matches);
    mql.addEventListener("change", onChange);
    onChange();
    return () => mql.removeEventListener("change", onChange);
  }, []);
  return dark;
};
